import { useEffect } from 'react';
import { connect } from 'react-redux';

import pluralize from 'pluralize';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import CommunityCommentComponent from './CommunityCommentComponent';

import { getBuildingsForFilter } from '../../Building/actionCreators';
import { confirmDeleteComment, getPostCommentsList } from '../actions';

import { scrollIntoView } from '../../../utils';
import { getOlderCommentsCount } from '../utils';

import { COMMUNITY_COMMENT_INPUT_ID } from '../constants';

import * as buildingSelectors from '../../Building/selectors';
import * as commonSelectors from '../../Shared/selectors';
import * as communitySelectors from '../selectors';

import { ButtonLink } from '../../Button';
import { CommentSkeleton } from '../../Shared/skeletons';

const CommunityCommentContainer = (props) => {
  const {
    getPostComments,
    currentPostId,
    comments,
    buildings,
    isLoading,
    onRemoveComment,
  } = props;
  const {
    results,
    next: olderComments,
    previous: newerComments,
    count,
  } = comments;

  const shownComments = results ? [...results] : [];
  const olderCommentsCount = getOlderCommentsCount(olderComments, count);
  const nextCommentsCount = newerComments ? 10 : 0;

  useEffect(() => {
    getPostComments(currentPostId);
  }, []);

  const onLoadNextComment = async () => {
    await getPostComments(currentPostId, newerComments);
    scrollIntoView(`${COMMUNITY_COMMENT_INPUT_ID}_${currentPostId}`);
  };

  if (isLoading && !shownComments?.length) return <CommentSkeleton />;

  const olderCommentsLabel = `See ${olderCommentsCount} previous ${pluralize(
    'comment',
    olderCommentsCount,
  )}`;
  const nextCommentsLabel = `See ${nextCommentsCount} next ${pluralize(
    'comment',
    nextCommentsCount,
  )}`;

  return (
    <Box my="2rem">
      {!!olderComments && (
        <Box mb="4rem">
          <ButtonLink
            onClick={() => getPostComments(currentPostId, olderComments)}
          >
            {olderCommentsLabel}
          </ButtonLink>
        </Box>
      )}
      {shownComments?.reverse()?.map((comment) => (
        <CommunityCommentComponent
          key={comment.id}
          comment={comment}
          currentPostId={currentPostId}
          buildings={buildings}
          onRemoveComment={onRemoveComment}
        />
      ))}
      {!!newerComments && (
        <ButtonLink onClick={onLoadNextComment}>{nextCommentsLabel}</ButtonLink>
      )}
    </Box>
  );
};

CommunityCommentContainer.propTypes = {
  getPostComments: PropTypes.func.isRequired,
  currentPostId: PropTypes.number.isRequired,
  buildings: PropTypes.instanceOf(Object).isRequired,
  comments: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onRemoveComment: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  comments: communitySelectors.getPostCommentsList(state, ownProps),
  buildings: buildingSelectors.getBuildings(state),
  isLoading: commonSelectors.getIsLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  getPostComments: (postId, queryParams) =>
    getPostCommentsList(dispatch, postId, {
      ...queryParams,
      status: 'approved,pending',
    }),
  getBuildings: () => getBuildingsForFilter(dispatch),
  onRemoveComment: (postId, commentId) =>
    confirmDeleteComment(dispatch, postId, commentId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommunityCommentContainer);
